(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mnly-athlete-lander"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-ath]');
  if (!root) return;
  var gate = root.querySelector('[data-ath-gate]');
  var form = root.querySelector('[data-ath-form]');
  var input = root.querySelector('[data-ath-input]');
  var err = root.querySelector('[data-ath-err]');
  var SALT = 'mnly-ath-v1';
  var KEY = 'mnly_ath_pw';
  var code = null;

  function hex2buf(h) {
    var a = new Uint8Array(h.length / 2);
    for (var i = 0; i < a.length; i++) a[i] = parseInt(h.substr(i * 2, 2), 16);
    return a;
  }
  function buf2hex(b) {
    return Array.prototype.map.call(new Uint8Array(b), function (x) { return x.toString(16).padStart(2, '0'); }).join('');
  }
  function norm(v) { return (v || '').trim().toLowerCase(); }

  function verify(pw) {
    var enc = new TextEncoder();
    return crypto.subtle.digest('SHA-256', enc.encode(SALT + pw)).then(function (h) {
      return buf2hex(h) === root.getAttribute('data-hash');
    });
  }

  function decryptCode(pw) {
    var enc = new TextEncoder();
    return crypto.subtle.importKey('raw', enc.encode(pw), 'PBKDF2', false, ['deriveKey'])
      .then(function (km) {
        return crypto.subtle.deriveKey(
          { name: 'PBKDF2', salt: enc.encode(SALT), iterations: 100000, hash: 'SHA-256' },
          km, { name: 'AES-GCM', length: 256 }, false, ['decrypt']
        );
      })
      .then(function (key) {
        return crypto.subtle.decrypt(
          { name: 'AES-GCM', iv: hex2buf(root.getAttribute('data-iv')) },
          key, hex2buf(root.getAttribute('data-ct'))
        );
      })
      .then(function (pt) { return new TextDecoder().decode(pt); });
  }

  function lock() { document.documentElement.setAttribute('scroll-lock', ''); }
  function openGate() {
    document.documentElement.removeAttribute('scroll-lock');
    gate.classList.add('is-out');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.setTimeout(function () { gate.hidden = true; }, reduced ? 0 : 320);
  }

  function unlock(pw, remember) {
    return decryptCode(pw).then(function (c) {
      code = c;
      if (remember) { try { sessionStorage.setItem(KEY, pw); } catch (e) {} }
      openGate();
      return true;
    });
  }

  lock();
  var saved = null;
  try { saved = sessionStorage.getItem(KEY); } catch (e) {}
  if (saved) {
    verify(saved).then(function (ok) {
      if (ok) return unlock(saved, false);
      try { sessionStorage.removeItem(KEY); } catch (e) {}
      input.focus();
    }).catch(function () { input.focus(); });
  } else {
    input.focus();
  }

  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    err.hidden = true;
    var pw = norm(input.value);
    if (!pw) return;
    verify(pw).then(function (ok) {
      if (!ok) throw new Error('bad code');
      return unlock(pw, true);
    }).catch(function () {
      err.hidden = false;
      input.select();
    });
  });

  var buttons = root.querySelectorAll('[data-ath-add]');
  Array.prototype.forEach.call(buttons, function (btn) {
    btn.addEventListener('click', function () {
      if (!code) return;
      var states = root.querySelectorAll('[data-ath-state]');
      Array.prototype.forEach.call(buttons, function (b) { b.disabled = true; });
      Array.prototype.forEach.call(states, function (s) { s.hidden = false; s.textContent = 'Adding…'; });
      var kit = root.getAttribute('data-kit');
      var mem = root.getAttribute('data-mem');
      Promise.all([
        fetch('/products/' + kit + '.js').then(function (r) { return r.json(); }),
        fetch('/products/' + mem + '.js').then(function (r) { return r.json(); })
      ])
        .then(function (prods) {
          var kv = prods[0].variants[0];
          var mv = prods[1].variants[0];
          var items = [{ id: kv.id, quantity: 1 }];
          var memItem = { id: mv.id, quantity: 1 };
          var alloc = (mv.selling_plan_allocations || [])[0];
          if (alloc) memItem.selling_plan = alloc.selling_plan_id;
          items.push(memItem);
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          location.href = '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcheckout';
        })
        .catch(function () {
          Array.prototype.forEach.call(buttons, function (b) { b.disabled = false; });
          Array.prototype.forEach.call(states, function (s) { s.hidden = false; s.textContent = 'Something went wrong. Tap again.'; });
        });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mnly-cart"]) return;
  try {
    
(function () {
  function bind(root) {
    [].forEach.call(root.querySelectorAll('[data-cp-form]'), function (form) {
      form.addEventListener('submit', function (e) {
        var btn = e.submitter;
        if (!btn || !window.fetch) return;
        e.preventDefault();
        var id = root.getAttribute('data-section');
        root.classList.add('is-busy');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: Number(form.elements.line.value), quantity: Number(btn.value) })
        })
          .then(function (r) { if (!r.ok) throw new Error('change failed'); return r.json(); })
          .then(function (cart) {
            var bubble = document.querySelector('.mnly-header__cart-count');
            if (bubble) { bubble.textContent = cart.item_count; bubble.hidden = cart.item_count === 0; }
            return fetch(location.pathname + '?sections=' + encodeURIComponent(id));
          })
          .then(function (r) { return r.json(); })
          .then(function (json) {
            var doc = new DOMParser().parseFromString(json[id], 'text/html');
            var next = doc.querySelector('[data-mnly-cp]');
            if (!next) return location.reload();
            // Keep the live wallet buttons: Shopify's script initialised
            // them once and does not re-run on swapped-in markup.
            var wallets = root.querySelector('.mnly-cp__wallets');
            var slot = next.querySelector('.mnly-cp__wallets');
            if (wallets && slot) slot.replaceWith(wallets);
            root.replaceWith(next);
            bind(next);
          })
          .catch(function () { location.reload(); });
      });
    });
  }
  var root = document.querySelector('[data-mnly-cp]');
  if (root) bind(root);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mnly-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-mnly-header]');
    if (!header) return;

    var spacer = document.querySelector('.mnly-header-spacer');
    if (spacer && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          header.classList.toggle('is-docked', !entries[0].isIntersecting);
        },
        { rootMargin: '-17px 0px 0px 0px' }
      ).observe(spacer);
    } else {
      header.classList.add('is-docked');
    }

    var burger = header.querySelector('[data-mnly-burger]');
    var mobile = header.querySelector('#mnly-mobile-menu');
    if (!burger || !mobile) return;

    /* Everything in the page except the header group; made inert while the
       takeover is up so Tab cannot walk out of an opaque overlay. */
    var behind = Array.prototype.filter.call(document.querySelectorAll('.page-wrapper > *'), function (n) {
      return n.id !== 'header-group';
    });
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var hideTimer;

    function isOpen() {
      return burger.getAttribute('aria-expanded') === 'true';
    }

    function setOpen(open) {
      burger.setAttribute('aria-expanded', String(open));
      header.classList.toggle('is-menu-open', open);
      /* Same lock the waitlist drawer uses (html[scroll-lock], assets/base.css)
         rather than a second mechanism. */
      document.documentElement.toggleAttribute('scroll-lock', open);
      behind.forEach(function (n) {
        n.inert = open;
      });
      window.clearTimeout(hideTimer);

      if (open) {
        mobile.hidden = false;
        requestAnimationFrame(function () {
          mobile.classList.add('is-on');
        });
        /* Focus the sheet itself (dialog practice): no focus ring flashes on
           the first link at open, and the next Tab lands inside the menu. */
        mobile.setAttribute('tabindex', '-1');
        mobile.focus({ preventScroll: true });
      } else {
        mobile.classList.remove('is-on');
        hideTimer = window.setTimeout(function () {
          mobile.hidden = true;
        }, reduce.matches ? 0 : 200);
        burger.focus({ preventScroll: true });
      }
    }

    burger.addEventListener('click', function () {
      setOpen(!isOpen());
    });
    mobile.addEventListener('click', function (e) {
      if (e.target.closest('a[href]')) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) setOpen(false);
    });
    /* Resizing up to the desktop nav would otherwise strand the scroll lock. */
    window.matchMedia('(min-width: 990px)').addEventListener('change', function (e) {
      if (e.matches && isOpen()) setOpen(false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mnly-loop"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var grid = document.querySelector('[data-mnly-loop]');
    if (!grid) return;
    var btns = Array.prototype.slice.call(grid.querySelectorAll('.mnly-loop2__btn'));
    var viss = Array.prototype.slice.call(grid.querySelectorAll('.mnly-loop2__vis'));
    var num = grid.querySelector('[data-mnly-loop-num]');
    var desc = grid.querySelector('[data-mnly-loop-desc]');
    var descs = Array.prototype.slice.call(grid.querySelectorAll('[data-mnly-desc-src]')).map(function (el) { return el.textContent; });
    if (!btns.length || !viss.length) return;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cur = 0, timer = null, visible = false;
    var card = grid.querySelector('.mnly-loop2__card');
    var sweep = grid.querySelector('[data-mnly-loop-timer]');
    var dots = Array.prototype.slice.call(grid.querySelectorAll('.m-loop-dot'));
    function syncTimer(delay) {
      if (!card || !sweep || reduced) return;
      card.classList.remove('is-live');
      sweep.style.animation = 'none';
      void sweep.offsetWidth;
      sweep.style.animation = '';
      sweep.style.animationDuration = (delay / 1000) + 's';
      if (timer) card.classList.add('is-live');
    }

    var startAt = 0, remaining = 0, hovered = false;
    function schedule(delay) {
      if (reduced) return;
      if (timer) clearTimeout(timer);
      startAt = Date.now();
      remaining = delay;
      timer = visible && !hovered ? setTimeout(function () { set((cur + 1) % btns.length); }, delay) : null;
    }
    function setPlayState(state) {
      var bar = btns[cur].querySelector('.bar i');
      if (bar) bar.style.animationPlayState = state;
      if (sweep) sweep.style.animationPlayState = state;
    }
    function pause() {
      if (reduced || hovered) return;
      hovered = true;
      if (timer) {
        clearTimeout(timer);
        timer = null;
        remaining -= Date.now() - startAt;
      }
      setPlayState('paused');
    }
    function resume() {
      if (reduced || !hovered) return;
      hovered = false;
      setPlayState('');
      if (!visible) return;
      if (remaining > 60) {
        startAt = Date.now();
        timer = setTimeout(function () { set((cur + 1) % btns.length); }, remaining);
      } else {
        set((cur + 1) % btns.length);
      }
    }
    function set(i) {
      btns[cur].classList.remove('on');
      btns[cur].setAttribute('aria-selected', 'false');
      viss[cur].classList.remove('on');
      cur = i;
      var b = btns[cur];
      b.classList.add('on');
      b.setAttribute('aria-selected', 'true');
      var bar = b.querySelector('.bar i');
      if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
      viss[cur].classList.add('on');
      if (num) num.textContent = 'STAGE 0' + (cur + 1) + ' / 05';
      if (desc && descs[cur]) desc.textContent = descs[cur];
      dots.forEach(function (d, j) {
        d.classList.toggle('on', j === cur);
        if (j === cur) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
      schedule(4200);
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { set(i); });
    });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { set(i); });
    });

    /* Mobile: swipe the card left/right. Routes through set(), so the
       auto-advance reschedules exactly as a tab click does. Nothing calls
       preventDefault, and the axis lock abandons the gesture the moment it
       reads as vertical, so page scroll is never hijacked.

       No translateX follow on the drag: the card is [data-reveal], so
       mnly-smooth.js owns its inline transform during the entrance and
       .mnly-motion [data-reveal] kills the transition that would ease it back.
       Fighting that engine for 24px of pull is not worth the jitter. */
    if (card) {
      var SWIPE = 45, LOCK = 8;
      var tracking = false, didPause = false, axis = '', sx = 0, sy = 0, dx = 0;
      card.addEventListener('touchstart', function (e) {
        if (window.innerWidth > 900 || e.touches.length !== 1) return;
        tracking = true; axis = ''; dx = 0; didPause = false;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
      }, { passive: true });
      card.addEventListener('touchmove', function (e) {
        if (!tracking || axis === 'y' || e.touches.length !== 1) return;
        dx = e.touches[0].clientX - sx;
        var dy = e.touches[0].clientY - sy;
        if (!axis) {
          if (Math.abs(dx) < LOCK && Math.abs(dy) < LOCK) return;
          axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (axis === 'x' && !hovered) { pause(); didPause = true; }
        }
      }, { passive: true });
      var endSwipe = function () {
        if (!tracking) return;
        tracking = false;
        if (axis === 'x' && Math.abs(dx) >= SWIPE) {
          if (didPause) { hovered = false; setPlayState(''); }
          set(dx < 0 ? (cur + 1) % btns.length : (cur + btns.length - 1) % btns.length);
        } else if (didPause) {
          resume();
        }
        axis = ''; dx = 0; didPause = false;
      };
      card.addEventListener('touchend', endSwipe, { passive: true });
      card.addEventListener('touchcancel', endSwipe, { passive: true });
    }
    var rail = grid.querySelector('.mnly-loop2__rail');
    if (rail) {
      rail.addEventListener('mouseenter', pause);
      rail.addEventListener('mouseleave', resume);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        visible = e[0].isIntersecting;
        if (visible) schedule(4200);
        else if (timer) { clearTimeout(timer); timer = null; }
      }, { threshold: 0.25 }).observe(grid);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mnly-offer-lander"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-offer]');
  if (!root) return;
  var ends = Date.parse(root.getAttribute('data-ends'));
  if (isNaN(ends)) return;
  var units = {};
  [].forEach.call(root.querySelectorAll('[data-u]'), function (el) { units[el.getAttribute('data-u')] = el; });
  var dockTime = root.querySelector('[data-offer-dock-time]');
  var timer;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function end() {
    clearInterval(timer);
    document.documentElement.classList.add('mnly-offer-ended');
    [].forEach.call(document.querySelectorAll('[data-evl-add]'), function (b) {
      b.disabled = true;
      var label = b.querySelector('[data-evl-label]') || b;
      label.textContent = 'Offer ended';
      var arr = b.querySelector('.arr');
      if (arr) arr.remove();
    });
    root.querySelector('[data-offer-ended-msg]').hidden = false;
  }

  function tick() {
    var left = Math.floor((ends - Date.now()) / 1000);
    if (left <= 0) return end();
    var d = Math.floor(left / 86400);
    var h = Math.floor(left % 86400 / 3600);
    var m = Math.floor(left % 3600 / 60);
    var s = left % 60;
    units.d.textContent = pad(d);
    units.h.textContent = pad(h);
    units.m.textContent = pad(m);
    units.s.textContent = pad(s);
    var txt = (d ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm';
    if (dockTime) dockTime.textContent = 'Ends in ' + txt;
  }

  tick();
  if (!document.documentElement.classList.contains('mnly-offer-ended')) timer = setInterval(tick, 1000);

  var dock = root.querySelector('[data-offer-dock]');
  var cta = root.querySelector('[data-offer-cta]');
  if (dock && cta && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var off = !entries[0].isIntersecting;
      dock.classList.toggle('is-on', off);
      dock.setAttribute('aria-hidden', off ? 'false' : 'true');
      dock.querySelector('button').tabIndex = off ? 0 : -1;
    }).observe(cta);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mnly-pdp-arrives"] && !Shopify.designMode) return;
  try {
    
  /* Mini-rail highlight follows the scrolled card. Scrolling itself is the
     anchor's job, so with JS off the carousel still swipes and node 1 stays lit. */
  (function () {
    var rail = document.querySelector('.mjr__rail');
    if (!rail || !('IntersectionObserver' in window)) return;
    var links = Array.prototype.slice.call(document.querySelectorAll('.mjr__mini'));
    if (!links.length) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          links.forEach(function (a) {
            a.classList.toggle('is-on', a.getAttribute('href') === '#' + e.target.id);
          });
        });
      },
      { root: rail, threshold: 0.6 }
    );
    rail.querySelectorAll('.mjr__step').forEach(function (s) {
      io.observe(s);
    });
  })();

  /* Pointer drag for the desktop rail. Native touch already has momentum, so
     touch pointers are skipped. A drag past the threshold swallows the click
     so it never fires the Precision Packs link inside a card. Own hooks - this
     deliberately does not reuse the mnly-voices bindings. */
  (function () {
    var THRESHOLD = 6;
    document.querySelectorAll('.mjr .mjr__rail').forEach(function (rail) {
      if (rail.dataset.mjrDrag) return;
      rail.dataset.mjrDrag = '1';
      var down = false,
        moved = false,
        x0 = 0,
        left0 = 0;

      rail.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        down = true;
        moved = false;
        x0 = e.clientX;
        left0 = rail.scrollLeft;
        rail.classList.add('is-dragging');
      });
      rail.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - x0;
        if (!moved && Math.abs(dx) < THRESHOLD) return;
        moved = true;
        rail.scrollLeft = left0 - dx;
      });
      function end() {
        if (!down) return;
        down = false;
        rail.classList.remove('is-dragging');
        if (moved) setTimeout(function () { moved = false; }, 0);
      }
      rail.addEventListener('pointerup', end);
      rail.addEventListener('pointercancel', end);
      rail.addEventListener('pointerleave', end);
      rail.addEventListener(
        'click',
        function (e) {
          if (moved) {
            e.stopPropagation();
            e.preventDefault();
          }
        },
        true
      );
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mnly-pdp-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-mnly-buybar]');
    var hero = document.querySelector('.mnly-pdp-hero__buy');
    if (bar && hero && typeof IntersectionObserver === 'function') {
      bar.hidden = false;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-on', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }).observe(hero);
    }

    document.querySelectorAll('[data-mnly-gal]').forEach(function (gal) {
      var stage = gal.querySelector('[data-gal-stage]');
      var slides = [].slice.call(gal.querySelectorAll('[data-gal-slide]'));
      var thumbs = [].slice.call(gal.querySelectorAll('[data-gal-thumb]'));
      var counter = gal.querySelector('[data-gal-count]');
      if (!stage || slides.length < 2) return;

      var index = 0;
      var ticking = false;

      function pad(n) {
        return (n < 10 ? '0' : '') + n;
      }

      function paint(n) {
        if (n === index) return;
        index = n;
        thumbs.forEach(function (t, i) {
          t.classList.toggle('is-on', i === n);
        });
        if (counter) counter.textContent = pad(n + 1) + ' / ' + pad(slides.length);
      }

      function go(n) {
        n = Math.max(0, Math.min(slides.length - 1, n));
        stage.scrollLeft = slides[n].offsetLeft - slides[0].offsetLeft;
      }

      stage.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            paint(Math.round(stage.scrollLeft / stage.clientWidth));
          });
        },
        { passive: true }
      );

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          go(i);
        });
      });

      var prev = gal.querySelector('[data-gal-prev]');
      var next = gal.querySelector('[data-gal-next]');
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mnly-spdp-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mnly-sgal]').forEach(function (gal) {
    var stage = gal.querySelector('[data-sgal-stage]');
    var slides = [].slice.call(gal.querySelectorAll('[data-sgal-slide]'));
    var thumbs = [].slice.call(gal.querySelectorAll('[data-sgal-thumb]'));
    var counter = gal.querySelector('[data-sgal-count]');
    if (!stage || slides.length < 2) return;

    var index = 0;
    var ticking = false;

    function pad(n) {
      return (n < 10 ? '0' : '') + n;
    }

    function paint(n) {
      if (n === index) return;
      index = n;
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-on', i === n);
      });
      if (counter) counter.textContent = pad(n + 1) + ' / ' + pad(slides.length);
    }

    function go(n) {
      n = Math.max(0, Math.min(slides.length - 1, n));
      stage.scrollLeft = slides[n].offsetLeft - slides[0].offsetLeft;
    }

    stage.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          paint(Math.round(stage.scrollLeft / stage.clientWidth));
        });
      },
      { passive: true }
    );

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        go(i);
      });
    });

    var prev = gal.querySelector('[data-sgal-prev]');
    var next = gal.querySelector('[data-sgal-next]');
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mnly-survey"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.mnly-survey [data-tf-live]')) window.tf?.load?.();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mnly-voices"] && !Shopify.designMode) return;
  try {
    
/* Pointer drag for the voices rail. Native touch already has momentum;
   this only adds mouse/pen dragging on desktop. A drag past the
   threshold swallows the click so it never toggles a card's sound. */
(function () {
  var THRESHOLD = 6;
  document.querySelectorAll('.mnly-vb .m-vc-rail').forEach(function (rail) {
    if (rail.dataset.vbDrag) return;
    rail.dataset.vbDrag = '1';
    var down = false, moved = false, x0 = 0, left0 = 0;

    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; moved = false; x0 = e.clientX; left0 = rail.scrollLeft;
      rail.classList.add('is-dragging');
    });
    rail.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - x0;
      if (!moved && Math.abs(dx) < THRESHOLD) return;
      moved = true;
      rail.scrollLeft = left0 - dx;
    });
    function end() {
      if (!down) return;
      down = false;
      rail.classList.remove('is-dragging');
      if (moved) setTimeout(function () { moved = false; }, 0);
    }
    rail.addEventListener('pointerup', end);
    rail.addEventListener('pointercancel', end);
    rail.addEventListener('pointerleave', end);
    rail.addEventListener('click', function (e) {
      if (moved) { e.stopPropagation(); e.preventDefault(); }
    }, true);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
